import * as React from 'react';
import { memo } from 'react';

type BevelProps = {
	color: string;
	modifier?: string;
};

const Bevel = ({ color, modifier }: BevelProps) =>
	color ? (
		<div className={`h-bevel${modifier ? ` h-bevel--${modifier}` : ''}`} style={{ color: `#${color}` }} />
	) : null;

export { Bevel };

export default memo(Bevel, (prevProps, nextProps) => {
	return prevProps.color === nextProps.color;
});
